import $ from 'jquery';

import { Component } from '../core/component';


// The createCalendar comes from the add-to-calender script.
// It needs to be manually added to each page that needs the functionality
export class AddToCalendar extends Component {
    constructor() {
        super();
        this.selector = '.js-add-to-calendar';
    }

    init() {
        this.$elements.each((index, element) => {
            const $el = $(element);

            const data = {
                title: $el.data('title'),
                start: new Date($el.data('start-time')),
                end: new Date($el.data('end-time')),
                address: $el.data('address'),
            };

            const calendar = window.createCalendar({
                options: {
                    class: 'event-detail__add-to-calendar js-calendar-dropdown',
                },
                data,
            });

            $el.replaceWith(calendar);
            $('.js-calendar-dropdown label')
                .prepend('<i class="far fa-calendar-plus" aria-hidden="true" role="img"></i>');
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/addToCalendar.js